export enum ELastActionChat {
  sentMessage = "Sent Message",
  receivedMessage = "Received Message",
  loadMoreMessages = "Load More Messages",
  loadMessages = "Load Messages",
}
